import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    searchString: '',
    pageNumber: 0,
  },
  previouslySelectedRow: null,
}

const getSKUsShouldCostFilters = createSlice({
  name: 'sku-list-filters',
  initialState: initialState,
  reducers: {
    setSKUsListFilters: (state, action) => {
      state.filters = action.payload
    },
    resetSKUsFiltersSlice: () => initialState,
    setSKUsListPreviouslySelectedRow: (state, action) => {
      state.previouslySelectedRow = action.payload
    },
  },
})

export const { setSKUsListFilters, resetSKUsFiltersSlice, setSKUsListPreviouslySelectedRow } =
  getSKUsShouldCostFilters.actions

export default getSKUsShouldCostFilters.reducer